import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { useUserState, useUserStateDispatch } from 'contexts/auth-context';
import { userState } from 'contexts/actions/authActions';
import t from 'utils/translateFunc';
import { getRequest, putRequest } from 'utils/requests';

import trackingEvent from 'utils/trackingEvent';

import {
  NavRelease,
  TextField,
  BtnPurpleTransparent32,
  BtnGreen32,
  Icon,
  SelectCustom,
  Loader
} from 'components/common/Elements/Elements';

import classes from './UserProfile.module.scss';

const optionsLng = [
  { value: 'Українська', label: 'Українська' },
  { value: 'English', label: 'English' },
  { value: 'Русский', label: 'Русский' }
];

// const optionsTimezone = [{ value: 'Europe/Kiev', label: 'Europe/Kiev' }];

const UserProfile = ({ mixpanel }) => {
  let history = useHistory();
  const language = useUserState().user.language;
  const username = useUserState().user.username;
  const userStor = { ...useUserState().user };

  const [currentUserName, setCurrentUserName] = useState('');
  const [modeSetting, setModeSetting] = useState('auth');
  const [name, setName] = useState({
    username: '',
    password: '',
    confirmpass: '',
    oldpass: '',
    firstname: '',
    lastname: '',
    email: ''
  });
  const [wrongText, setWrongText] = useState({
    username: '',
    password: '',
    confirmpass: '',
    oldpass: '',
    firstname: '',
    lastname: '',
    email: ''
  });
  const [lngChoose, setLngChoose] = useState({
    value: 'Українська',
    label: 'Українська'
  });

  const dispatch = useUserStateDispatch();

  const [loading, setLoading] = useState(true);
  const [isDesebled, setIsDesebled] = useState(true);

  // const [timeZone, setTimeZone] = useState({
  //   value: 'Europe/Kiev',
  //   label: 'Europe/Kiev'
  // });

  const dataNav = [
    { name: t('userProfile', 'SETTING_AUTH', language), id: 'auth' },
    { name: t('userProfile', 'PERSONAL_SETTING', language), id: 'personal' }
  ];

  useEffect(() => {
    const url = `/api/users/me/`;
    getRequest(url)
      .then(res => {
        setCurrentUserName(res.username);
        setName({
          ...name,
          username: res.username,
          firstname: res.firstName,
          lastname: res.lastName,
          email: res.email
        });

        setLngChoose(
          res.language === 'uk'
            ? optionsLng[0]
            : res.language === 'en'
            ? optionsLng[1]
            : optionsLng[2]
        );
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const onClickSetting = id => {
    if (id === 'auth') {
      trackingEvent('auth_setting', mixpanel, username);
    } else if (id === 'personal') {
      trackingEvent('personal_setting', mixpanel, username);
    }
    setModeSetting(id);
  };

  const onSubmit = e => {
    trackingEvent('save_setting', mixpanel, username);
    e.preventDefault();

    if (name.password !== name.confirmpass && name.password.length <= 16) {
      setWrongText({
        password: ' ',
        confirmpass: t('error', 'ERR_DIFFERENT_PASS', language)
      });
      setModeSetting('auth');
      return;
    }

    const url = `/api/users/${currentUserName}/`;

    const FOR_REQ_BODY = {
      username: name.username,
      email: name.email,
      name: '',
      language:
        lngChoose.label === optionsLng[0].label
          ? 'uk'
          : lngChoose.label === optionsLng[1].label
          ? 'en'
          : 'ru',
      firstName: name.firstname,
      lastName: name.lastname,
      passwordOld: name.oldpass,
      passwordNew: name.password
    };

    const REQ_BODY = {};
    const keyREQBode = Object.keys(FOR_REQ_BODY);

    keyREQBode.forEach(el => {
      if (FOR_REQ_BODY[el]) {
        REQ_BODY[el] = FOR_REQ_BODY[el];
      }
    });

    putRequest(url, REQ_BODY)
      .then(() => {
        userState({
          ...userStor,
          language:
            lngChoose.label === optionsLng[0].label
              ? 'uk'
              : lngChoose.label === optionsLng[1].label
              ? 'en'
              : 'ru',
          username: name.username
        })(dispatch);
        history.goBack();
      })
      .catch(err => {
        setWrongText({
          oldpass: t('error', 'ERR_PASS', language)
        });
        setModeSetting('auth');
      });
  };

  const onName = e => {
    setName({ ...name, [e.target.name]: e.target.value });
    setIsDesebled(false);
  };

  const onChangeSelectLng = value => {
    setLngChoose(value);
    setIsDesebled(false);
  };

  // const onChangeSelectTimeZone = value => {
  //   setTimeZone(value);
  // };

  const onCancel = () => {
    trackingEvent('cancel_setting', mixpanel, username);
    history.goBack();
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className={classes.userProfileWrap}>
      <div className={classes.userProfile}>
        <h2 className={classes.title}>
          {t('userProfile', 'SETTING_PROFILE', language)}
        </h2>
        <NavRelease
          dataNav={dataNav}
          onClickChips={onClickSetting}
          modeWidth
          modeUser
          modeSetting={modeSetting}
        />
        <form onSubmit={onSubmit} className={classes.form}>
          {modeSetting === 'auth' && (
            <div className={classes.fieldBox}>
              <div className={classes.fieldSection}>
                <section>
                  <TextField
                    name="username"
                    className={cn(
                      classes.textField,
                      classes.textField_withClarification
                    )}
                    value={name.username}
                    onChange={onName}
                    labelText={t('LoginPage', 'USERNAME', language)}
                    placeholder={t('userProfile', 'ENTER_USERNAME', language)}
                    errorText={wrongText.username}
                    boxShadow
                  />
                  {!wrongText.username && (
                    <p className={classes.clarification}>
                      {t('userProfile', 'CLARIFICATION', language)}
                    </p>
                  )}
                </section>
                <section className={classes.selectSection}>
                  <SelectCustom
                    selectTitle={t('userProfile', 'LANGUAGE', language)}
                    value={lngChoose}
                    onChange={onChangeSelectLng}
                    options={optionsLng}
                  />
                </section>
              </div>
              <div className={classes.fieldSection}>
                <TextField
                  required={
                    name.password || name.oldpass || name.confirmpass
                      ? true
                      : false
                  }
                  autoComplete="new-password"
                  name="password"
                  className={
                    wrongText.password && wrongText.password === ' '
                      ? classes.textField_errorServer
                      : wrongText.password
                      ? classes.textField_error
                      : classes.textField
                  }
                  value={name.password}
                  onChange={onName}
                  labelText={t('passwordReset', 'NEW_PASS', language)}
                  placeholder={t('passwordReset', 'ENTER_NEW_PASS', language)}
                  type="password"
                  errorText={wrongText.password}
                  boxShadow
                />
                <TextField
                  required={
                    name.password || name.oldpass || name.confirmpass
                      ? true
                      : false
                  }
                  name="confirmpass"
                  autoComplete="new-password"
                  className={
                    wrongText.confirmpass && wrongText.confirmpass === ' '
                      ? classes.textField_errorServer
                      : wrongText.confirmpass
                      ? classes.textField_error
                      : classes.textField
                  }
                  value={name.confirmpass}
                  onChange={onName}
                  labelText={t('passwordReset', 'CONFIRM_PASS', language)}
                  placeholder={t('passwordReset', 'ENTER_NEW_PASS', language)}
                  type="password"
                  errorText={wrongText.confirmpass}
                  boxShadow
                />
                <TextField
                  required={
                    name.password || name.oldpass || name.confirmpass
                      ? true
                      : false
                  }
                  name="oldpass"
                  autoComplete="new-password"
                  className={
                    wrongText.oldpass
                      ? classes.textField_error
                      : classes.textField
                  }
                  value={name.oldpass}
                  onChange={onName}
                  labelText={t('userProfile', 'OLD_PASS', language)}
                  placeholder={t('userProfile', 'ENTER_OLD_PASS', language)}
                  type="password"
                  errorText={wrongText.oldpass}
                  boxShadow
                />
              </div>
            </div>
          )}

          {modeSetting === 'personal' && (
            <div className={classes.fieldBox}>
              <div className={classes.fieldSection}>
                <section>
                  <TextField
                    name="firstname"
                    className={classes.textField}
                    value={name.firstname}
                    onChange={onName}
                    labelText={t('userProfile', 'FIRSTNAME', language)}
                    placeholder={t('userProfile', 'ENTER_FIRSTNAME', language)}
                    errorText={wrongText.firstname}
                    boxShadow
                  />
                  <TextField
                    name="lastname"
                    className={classes.textField}
                    value={name.lastname}
                    onChange={onName}
                    labelText={t('userProfile', 'LASTNAME', language)}
                    placeholder={t('userProfile', 'ENTER_LASTNAME', language)}
                    errorText={wrongText.lastname}
                    boxShadow
                  />
                </section>

                {/* <section className={classes.selectSection}>
                  <SelectCustom
                    selectTitle={t('userProfile', 'TIMEZONE', language)}
                    value={timeZone}
                    onChange={onChangeSelectTimeZone}
                    options={optionsTimezone}
                  />
                </section> */}
              </div>
              <div className={classes.fieldSection}>
                <TextField
                  name="email"
                  className={classes.textField}
                  value={name.email}
                  onChange={onName}
                  labelText={t('userProfile', 'EMAIL', language)}
                  placeholder={t('userProfile', 'ENTER_EMAIL', language)}
                  type="email"
                  errorText={wrongText.email}
                  boxShadow
                />
              </div>
            </div>
          )}
          <div className={classes.buttonBox}>
            <BtnGreen32
              textButton={t('createFirstRelease', 'SAVE', language)}
              type={'submit'}
              disabled={isDesebled}
            />
            <BtnPurpleTransparent32
              textButton={t('createFirstRelease', 'CANCEL', language)}
              onClick={onCancel}
              className={classes.cancelButton}
            />
          </div>
        </form>
      </div>
      <button type="button" onClick={onCancel} className={classes.clearBtn}>
        <Icon icon={'Icn_Clear-4'} className={classes.iconClear} />
      </button>
    </div>
  );
};

UserProfile.propTypes = {
  mixpanel: PropTypes.object
};

export default UserProfile;
